import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./qualification-skeleton.css";

const skeletonVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0.5 },
  visible: { opacity: 1 },
};

const QualificationSkeleton = ({ data = null }) => {
  const tabs = data?.tabs || [];
  const activeTabIndex = 0;
  const activeTabData = tabs[activeTabIndex]?.data || [];
  const entryCount = activeTabData.length > 0 ? activeTabData.length : 3;
  const skeletonEntries = Array.from({ length: entryCount }, (_, i) => i);

  const renderCardSkeleton = () => (
    <div className="qualification__entry" style={{ position: "relative", flex: 1 }}>
      <div className="qualification__card skeleton-card">
        <div className="qualification__card-header">
          <div className="skeleton-logo"></div>
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
            <div className="skeleton-text skeleton-title"></div>
            <div className="skeleton-text skeleton-company"></div>
            <div className="skeleton-text skeleton-location"></div>
            <div className="skeleton-text skeleton-date"></div>
          </div>
        </div>

        {/* Achievements skeleton (inside card) */}
        <div className="qualification__card-section">
          <div className="skeleton-text" style={{ width: "120px", height: "14px", marginBottom: "8px" }}></div>
          <div className="skeleton-text" style={{ width: "90%", height: "12px", marginBottom: "6px" }}></div>
          <div className="skeleton-text" style={{ width: "75%", height: "12px", marginBottom: "6px" }}></div>
        </div>

        {/* Tech stack chips skeleton (inside card) */}
        <div className="qualification__card-section">
          <div className="skeleton-text" style={{ width: "100px", height: "14px", marginBottom: "8px" }}></div>
          <div style={{ display: "flex", gap: "6px" }}>
            <div className="skeleton-chip"></div>
            <div className="skeleton-chip" style={{ width: "65px" }}></div>
            <div className="skeleton-chip" style={{ width: "50px" }}></div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <motion.section
      className="qualification section"
      id="qualification"
      initial="hidden"
      animate="visible"
      variants={skeletonVariants}
    >
      <motion.h2
        className="skeleton-text"
        variants={itemVariants}
        style={{
          width: "300px",
          height: "32px",
          marginBottom: "16px",
          margin: "0 auto 16px",
          display: "block",
        }}
      ></motion.h2>
      <motion.span
        className="skeleton-text"
        variants={itemVariants}
        style={{
          width: "200px",
          height: "16px",
          display: "block",
          marginBottom: "32px",
          margin: "0 auto 32px",
        }}
      ></motion.span>

      <motion.div
        className="qualification__container container"
        variants={skeletonVariants}
      >
        {/* Tab Buttons Skeleton */}
        <motion.div className="qualification__tabs" variants={itemVariants}>
          <div className="qualification__button skeleton-button">
            <span className="qualification__icon skeleton-icon"></span>
            <span
              className="skeleton-text"
              style={{ width: "100px", height: "20px" }}
            ></span>
          </div>
          <div className="qualification__button skeleton-button">
            <span className="qualification__icon skeleton-icon"></span>
            <span
              className="skeleton-text"
              style={{ width: "100px", height: "20px" }}
            ></span>
          </div>
        </motion.div>

        {/* Content Section Skeleton */}
        <motion.div
          className="qualification__sections"
          variants={skeletonVariants}
        >
          <motion.div
            className="qualification__content qualification__content-active"
            variants={itemVariants}
          >
            {/* Timeline entries */}
            {skeletonEntries.map((_, displayIndex) => (
              <motion.div
                key={displayIndex}
                className={`qualification__data ${
                  displayIndex % 2 === 0
                    ? "qualification__data--even"
                    : "qualification__data--odd"
                }`}
                variants={itemVariants}
              >
                {displayIndex % 2 === 0 ? (
                  <>
                    {renderCardSkeleton()}
                    {/* Center Timeline */}
                    <div>
                      <div className="qualification__rounder skeleton-rounder"></div>
                      <span className="qualification__line skeleton-line"></span>
                    </div>
                    {/* Right Empty */}
                    <div className="qualification__empty-col"></div>
                  </>
                ) : (
                  <>
                    {/* Left Empty */}
                    <div className="qualification__empty-col"></div>
                    {/* Center Timeline */}
                    <div>
                      <div className="qualification__rounder skeleton-rounder"></div>
                      <span className="qualification__line skeleton-line"></span>
                    </div>
                    {renderCardSkeleton()}
                  </>
                )}
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default QualificationSkeleton;
